import type { SelfserviceShortcutCategory } from 'de-zurich-ui-library'
import {
  createPersonalShortcutCategory,
  createShortcutCategory,
  type ShortcutTranslate
} from '@/utils/overviewSelfserviceShortcut'
import { isTrue } from '@/utils/CommonUtils'
import { isRedCooperationPartner } from '@/utilsTenant/RedCooperationUtils'

export const getOverviewSelfserviceShortcutCategories = (
  translate: ShortcutTranslate
): SelfserviceShortcutCategory[] => {
  const serviceLinks = globalThis.ENV_CONFIG?.SERVICE_LINKS
  const contractLinks = serviceLinks?.VERTRAGSSERVICES_PAGE
  const isRedPartner = isRedCooperationPartner()

  return [
    createPersonalShortcutCategory(translate),
    createShortcutCategory(
      'contract-services',
      'overviewSelfserviceShortcut.categories.contractServices',
      [
        {
          href: contractLinks?.CHANGE_MOTORVERSICHERUNGSUMFANG_PAGE,
          labelKey: 'overviewSelfserviceShortcut.links.changeCoverage',
          trackingId: 'shortcut-change-coverage',
          visible: !isRedPartner
        },
        {
          href: contractLinks?.CHANGE_MOTORFAHRLEISTUNG_PAGE,
          labelKey: 'overviewSelfserviceShortcut.links.changeMileage',
          trackingId: 'shortcut-change-mileage',
          visible: !isRedPartner
        },
        {
          href: contractLinks?.CHANGE_MOTORFAHRERKREIS_PAGE,
          labelKey: 'overviewSelfserviceShortcut.links.changeDrivers',
          trackingId: 'shortcut-change-drivers',
          visible: !isRedPartner
        },
        {
          href: contractLinks?.REQUEST_DIGITALCARD_PAGE,
          labelKey: 'overviewSelfserviceShortcut.links.requestDigitalCard',
          trackingId: 'shortcut-request-digital-card',
          visible: isTrue(globalThis.ENV_CONFIG?.FEATURE_FLAGS.ENABLE_DIGITAL_CARD)
        },
        {
          href: contractLinks?.REQUEST_IVK_PAGE,
          labelKey: 'overviewSelfserviceShortcut.links.requestIvk',
          trackingId: 'shortcut-request-ivk'
        },
        {
          href: contractLinks?.REQUEST_ACCOMPANYINGDRIVINGCERTIFICATE_PAGE,
          labelKey: 'overviewSelfserviceShortcut.links.requestAccompaniedDriving',
          trackingId: 'shortcut-request-accompanied-driving'
        },
        {
          href: contractLinks?.REQUEST_VEHICLESALE_PAGE,
          labelKey: 'overviewSelfserviceShortcut.links.reportVehicleSale',
          trackingId: 'shortcut-report-vehicle-sale'
        }
      ],
      translate
    )
  ]
}
